const React = require('react');
const Moment = require('moment')

let MyCardArticle = React.createClass({
  createMarkup() {
    return {__html: this.props.card.preamble};
  },

  render() {
    let author_link = "/profil/" + this.props.card.author_slug;
    let link = "/artikel/" + this.props.card.author_slug + "/" + this.props.card.slug;
    let stamp = Moment(this.props.card.publish);
    let dateFormat = stamp.format("DD.MM.YYYY");
    //console.log(this.props.card);
    return (
      <div>
        <h2 className="title-medium u-margin-b-s">{this.props.card.title}</h2>
        <div className="" dangerouslySetInnerHTML={this.createMarkup()}></div>
        <div className="l-grid">
          <div className="l-grid__item u-width-one-half">
            <div className="link" ><a href={link}>Läs mer &#8594;</a></div>
          </div>
          <div className="l-grid__item u-width-one-half">
            <div className="u-text-right">Datum: {dateFormat}</div>
            <div className="u-text-right">Skribent:<a href={author_link}><span className="link"> {this.props.card.author_name}</span></a></div>
        </div>
      </div>
     </div>
    );
  }
});


let MyCard = React.createClass({

  render() {
    let subCardPart = "";
    let link = "";
    let imgUrl = "";
    //console.log(this.props.card);
    switch(this.props.card.type){
      case 'article':
        link = "/" + this.props.card.link + '/' + this.props.card.author_slug  + '/' + this.props.card.slug;
        imgUrl = "/bilder/artikel-hog/" + this.props.card.img_id + "/" + this.props.card.slug + ".jpg";
        subCardPart = <MyCardArticle card={this.props.card} />
      default:

        break;
    }



    let imgStyle = {
        backgroundImage: "url(" + imgUrl + ")"
    };

    return (

      <div className="u-width-one-whole u-margin-b-m">
        <div className="card card-article">
          <a href={link}>
            <div className="card-thumbnail__article">
              <div className="card-thumbnail__image" style={imgStyle} ></div>
            </div>
          </a>
          <div className="u-padding-a-m">
          {subCardPart}
          </div>
        </div>
      </div>

    );
  }

});

module.exports = MyCard


// WEBPACK FOOTER //
// ./src/scripts/components/articlecard.js